/* src/app/shared/dialog/tv-plan-valuation-dialog/tv-plan-valuation-dialog.component.scss */
.clickable {
  cursor: pointer;
}
.general-and-option-container {
  display: flex;
  gap: 10px;
}
.title-and-button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 34px;
}
.price-values {
  color: rgba(255, 255, 255, 0);
}
.main-body-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0;
  border-bottom: 1px solid #DFEBF7;
  border-top: 1px solid #DFEBF7;
}
.page {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-row-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.formats-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
}
.icon-cancel {
  color: #FFF;
}
.form-column-container-align-left {
  align-self: start;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.row-justify-left {
  align-self: start !important;
  gap: 10px !important;
  justify-content: space-between !important;
}
.block-info {
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 5px;
  background: rgba(36, 70, 102, 0.05);
  gap: 5px;
}
.several-block-info-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.waves-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.single-wave-container {
  display: flex;
  align-items: center;
  gap: 10px;
}
.title-custom {
  justify-content: start;
  color: #F03C64;
  font: 700 14px FranceTV Brown;
}
.lib {
  font-size: 12px !important;
  margin-top: 5px;
}
.remark {
  color: #f03c64;
  font-size: 12px !important;
  margin-top: 5px;
}
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 20px;
}
/*# sourceMappingURL=tv-plan-valuation-dialog.component.css.map */
